import { FilterField } from '../FilterField';
import '../styles/filterColumn.css';
import type { ColumnFilterInputProps } from './columnFilterInput.types';

/**
 * Wraps FilterField in the compact column-header context.
 *
 * The .column-filter div sets CSS variables (--filter-height, --filter-font-size,
 * --filter-border-radius) consumed by the column variant sx functions.
 *
 * To add a new filter kind: add the strategy to FilterField — no changes here.
 */
export function ColumnFilterInput({ def, value, onChange, onClear }: ColumnFilterInputProps) {
  return (
    <div className="column-filter">
      <FilterField variant="column" def={def} value={value} onChange={onChange} onClear={onClear} />
    </div>
  );
}
